<template>
  <main class="landing_page_main">
    <a
      :href="routePubgCreateEvent('create')"
      class="top_mobile_btn light_blue"
    >CREATE AN EVENT</a>
    <banner />
    <boom-t-v-about v-if="!appConfig.isAvglDomain" />
    <avgl-about v-if="appConfig.isAvglDomain && !isAuth" />
    <events type="landing" />
    <trending-videos v-if="appConfig.isAvglDomain" />
  </main>
</template>

<script>
import Banner from './banner';
import { component } from '../../../mixins/component';
import BoomTVAbout from './BoomTVAbout';
import AvglAbout from './AvglAbout';
import Events from './events';
import TrendingVideos from './TrendingVideos';

export default {
  components: {
    TrendingVideos,
    BoomTVAbout,
    AvglAbout,
    Banner,
    Events,
  },
  mixins: [component],
};
</script>
